import { MoreInformationCashbackRequest } from "../../../../models/dashboard/marketplace/marketplaceCashbackRequestModel";
import {adminHttpClient} from "../../../../commons/adminHttpClinet";

const sendCashbackRequestMoreInformation = (model:MoreInformationCashbackRequest): Promise<any> => {
    return adminHttpClient.post(`/api/Admin/AdminMarketplacePurchase/send-cashback-request-more-info`, model)
}
export default sendCashbackRequestMoreInformation;